import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import NoLinkedEntitiesMessage from "../legalentity/NoLinkedEntitiesMessage";
import {fetchHierachy} from "../../actions/entity";
import EntityList from "../legalentity/EntityList";
import FormField from "../formField/FormField";
import {tpfaRoutes} from "../../routers/routes";
import {startTpfaApplication} from "../../actions/tpfaActions";

class TPFAStart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedEntity: null
        }
    }

    componentDidMount() {
        const {actions, impersonation} = this.props;
        actions.fetchHierachy(impersonation);
    }

    onSubmit = (e) => {

        e.preventDefault();
        const {actions, history, impersonation: {identityNumber}} = this.props;
        const {selectedEntity} = this.state;


        const cif = selectedEntity && selectedEntity.cif;

        const onProceed = (success = true, message = '') => {
            if (success) {
                history.push(tpfaRoutes.thirdParty);
            } else {
                this.setState({showHasNoApprovalMessage: true, message})
            }
        };

        if (/*this.validateForm()*/ true && cif) {
            actions.startTpfaApplication(identityNumber, selectedEntity, onProceed);
        }
    };

    handleSelect = (selectedEntity) => {
        this.setState({selectedEntity});
    };

    handleAcceptTsAndCs = () => {
        const {errors} = this.state;
        errors && errors.termsAccepted && this.handleResetError("termsAccepted");
        this.setState(prevState => ({termsAccepted: !prevState.termsAccepted}))
    };

    renderEntities = () => {
        const {entities} = this.props;
        const hasEntities = _.size(entities) > 0;

        if (!hasEntities) return null;
        const {selectedEntity} = this.state;

        return (
            <EntityList
                entities={entities}
                onSelect={this.handleSelect}
                selectedEntity={selectedEntity}
                style={{minHeight: '65vh'}}
            />
        );
    };

    renderTerms = () => {
        const {termsAccepted, errors} = this.state;
        return (
            <FormField
                className="form-group"
                error={errors && errors.termsAccepted && ["Terms And Conditions Should Be Accepted"]}
            >
                <div className="flexRow" style={{alignItems: "flex-start", textAlign: "left"}}>
                    <div className="icon-container" onClick={this.handleAcceptTsAndCs}>
                        <i
                            className={termsAccepted ? "fa fa-check-square-o" : "fa fa-square-o"}
                            style={{color: "rgb(0, 51, 170)", fontSize: 20, marginRight: 10}}
                        />
                    </div>
                    <p style={{margin: 0}}>
                        I agree to the
                        <a
                            target="_blank"
                            href="https://www.businessonline.standardbank.co.za/docs/Standard%20Bank%20Business%20Online%20Principal%20Electronic%20Banking%20Terms%20and%20Conditions.pdf">
                            Terms and Conditions
                        </a>
                        , including sourcing of entity details from public domain.
                    </p>
                </div>
            </FormField>
        )
    };

    renderFooter = () => {
        const {termsAccepted} = this.state;
        return (
            <div className="flexRow" style={{justifyContent: "space-between"}}>
                <div/>
                <button
                    className="action-btn-primary"
                    onClick={this.onSubmit}
                    type="button"
                    disabled={termsAccepted ? !termsAccepted : true}
                >Next
                </button>
            </div>
        )
    };

    render() {
        const {entities, loading} = this.props;
        if (loading) return null;

        const hasEntities = _.size(entities) > 0;
        if (!hasEntities) {
            return (
                <div className="page-container">
                    <div className="page-main-section">
                        <NoLinkedEntitiesMessage/>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="page-container">
                    <div className="col-md-5">
                        <div className="center form-group">
                            {this.renderEntities()}
                        </div>
                        <div className="column">
                            {this.renderTerms()}
                        </div>
                        <div className="page-footer-section">
                            {this.renderFooter()}
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps({entity, businessOnline, impersonation, loading}) {
    const hasEntities = entity && entity.entities;
    return {
        entities: hasEntities ? entity.entities : [],
        impersonation: impersonation && impersonation.impersonation ? impersonation.impersonation : {},
        loading
    }
}

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators({fetchHierachy, startTpfaApplication}, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPFAStart);